/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { AuthService } from '../../services/api/auth/AuthService';
import { RecoveryForm, NewPasswordForm, LoginForm } from '../../components/custom';
import { useAuthContext } from '../../context';
import { CustomAlert } from '../../components/shared';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

interface ILoginProps {
  children: React.ReactNode;
}

export const Auth: React.FC<ILoginProps> = ({ children }) => {

  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const { isAuthenticated, login } = useAuthContext();

  let tokenPage = '';
  const [reset, setReset] = useState(false);

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [requestError, setRequestError] = useState('');

  const [email, setEmail] = useState('');
  const [userError, setUserError] = useState('');
  const [recovery, setRecovery] = useState(false);

  const [processingMicrosoft, setProcessingMicrosoft] = useState(false);

  useEffect(() => {
    const verifyTokenAndSetState = async () => {
      const microsoftProcessed = await processMicrosoftCallback();
      if (!microsoftProcessed) {
        const result = await verifyToken();
        if (result == false) {
          removeTokenFromURL();
        }
      }
    };
    verifyTokenAndSetState();
  }, []);

  async function processMicrosoftCallback() {
    const microsoftToken = urlParams.get('microsoft_token');
    const userEncoded = urlParams.get('user');

    if (microsoftToken && userEncoded) {
      setProcessingMicrosoft(true);

      try {
        const tokenWithBearer = `Bearer ${microsoftToken}`;
        const encryptedToken = AuthService.encrypt(tokenWithBearer);
        sessionStorage.setItem('access_token', encryptedToken);
        const userJson = atob(userEncoded);
        const encryptedUser = AuthService.encrypt(userJson);
        localStorage.setItem('user_token', encryptedUser);

        window.location.replace('/dashboard');

        return true;

      } catch (error) {
        setAlertInfo({
          open: true,
          message: 'Erro ao processar login Microsoft',
          severity: 'error'
        });
        setProcessingMicrosoft(false);
        return false;
      }
    }

    return false;
  }

  async function verifyToken() {
    if (urlParams.has('token')) {
      const token = urlParams.get('token');
      if (token !== null) {
        setReset(true);
        tokenPage = token;
        return true;
      } else {
        console.log('erro');
        setReset(false);
        return false;
      }
    } else {
      setReset(false);
      return false;
    }
  }

  function removeTokenFromURL() {
    if (urlParams.has('token')) {
      urlParams.delete('token');
      window.history.replaceState({}, document.title, window.location.pathname);
      window.location.reload();
    }
  }

  const handleSubmitLogin = () => {
    setError(false);
    setPasswordError('');
    setUserError('');
    if (user.length > 0) {
      if (password.length > 5) {
        try {
          login(user, password);
          setError(false);
        } catch (erro) {
          setError(true);
        }
      } else {
        setPasswordError('Informe um senha valida');
      }
    } else {
      setUserError('Informe um usuário');
    }
  };

  const hendleSubmitRecovery = async () => {
    setError(false);
    const data: any = await AuthService.forgot_password(email);
    if (data !== undefined) {
      if (data instanceof AxiosError) {
        setError(true);
        setAlertInfo({ open: true, message: 'E-mail não encontrado', severity: 'error' });
      }
    } else {
      setError(false);
      setAlertInfo({ open: true, message: 'E-mail enviado! Verifique no span', severity: 'success' });
    setTimeout(() => {
      setAlertInfo(prev => ({ ...prev, open: false }));
    }, 5000);
    }
  };

	const currentUrl = window.location.href;
	const parsedUrl = new URL(currentUrl);

  const handleSubmitReset = async (token: string, new_password: string) => {
    if (new_password.length > 5) {
      const exchanged = await AuthService.reset_password(token, new_password);
      if (exchanged == false) {
        setAlertInfo({ open: true, message: 'Link expirado', severity: 'error' });
        setError(true);
      } else {
        setAlertInfo({ open: true, message: 'Senha alterada', severity: 'success' });
        window.location.href = `${parsedUrl.protocol}//${parsedUrl.hostname}`;
        setTimeout(() => {
          removeTokenFromURL();
        }, 1000);
				
      }
    } else {
      setPasswordError('Senha deve ter 5 digitos');
    }
  };

  const handleSubmitNewPassword = useCallback(async (newPassword: string) => {
    handleSubmitReset(tokenPage, newPassword);
  }, []);

  if (processingMicrosoft) {
    return (
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <div>Processando login Microsoft...</div>
      </Box>
    );
  }

  if (isAuthenticated) return (
    <>{children}</>
  );

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
      {recovery ? (
        <RecoveryForm
          handleSubmitRecovery={hendleSubmitRecovery}
          setEmail={setEmail}
          user={email}
          setRecovery={setRecovery}
          error={error}
          requestError={requestError}
        />
      ) : reset ? (
        <NewPasswordForm
          handleSubmitNewPassword={handleSubmitNewPassword}
          passwordError={passwordError}
          error={error}
          removeTokenFromURL={removeTokenFromURL}
        />

      ) : (
        <LoginForm
          user={user}
          setUser={setUser}
          userError={userError}
          password={password}
          setPassword={setPassword}
          passwordError={passwordError}
          handleSubmitLogin={handleSubmitLogin}
          setRecovery={setRecovery}
        />
      )}
      {alertInfo.open &&
        <CustomAlert
          severity={alertInfo.severity}
          message={alertInfo.message}
        />
      }
    </Box>
  );
};